import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import ReservationWidget from "./components/ReservationWidget";
import ScrollToTop from "./components/ScrollToTop";
import CookieConsent from "./components/feature/CookieConsent";
import WelcomeModal from "./components/WelcomeModal";
import TrackingScripts from "./components/TrackingScripts";
import DynamicSEO from "./components/DynamicSEO";

function App() {
  return (
    <BrowserRouter>
      <TrackingScripts />
      <DynamicSEO />
      <ScrollToTop />
      <AppRoutes />
      <ReservationWidget />
      <CookieConsent />
      <WelcomeModal />
    </BrowserRouter>
  );
}

export default App;
